import { render, staticRenderFns } from "./sort-dropdown.vue?vue&type=template&id=23df9241&scoped=true"
import script from "./sort-dropdown.vue?vue&type=script&lang=js"
export * from "./sort-dropdown.vue?vue&type=script&lang=js"
import style0 from "./sort-dropdown.vue?vue&type=style&index=0&id=23df9241&prod&lang=scss"
import style1 from "./sort-dropdown.vue?vue&type=style&index=1&id=23df9241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df9241",
  null
  
)

export default component.exports